var exports = {
  "button": "MediaPlaybackRate.module__button___NXY1R0",
  "small": "MediaPlaybackRate.module__small___NXY1R0",
  "medium": "MediaPlaybackRate.module__medium___NXY1R0",
  "large": "MediaPlaybackRate.module__large___NXY1R0",
  "active": "MediaPlaybackRate.module__active___NXY1R0",
  "label": "MediaPlaybackRate.module__label___NXY1R0",
};

__webpack_require__.r(module.exports = exports);
